import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { offerIncludes } from '../data/content';
import { CHECKOUT_URL, PRODUCT_IMAGE } from '../data/constants';
export function Offer() {
  return <section id="offer" className="grid-texture scroll-mt-4 border-y-2 border-green bg-steel px-4 py-8 sm:py-10" data-id="element-103" data-mp="1mmr24g0pg5ui">
      <div className="mx-auto max-w-2xl text-center" data-id="element-104" data-mp="1hqs5y694xjjj">
        <p className="inline-block rounded-full border border-green/60 bg-green/10 px-3 py-1 text-[0.6rem] font-bold uppercase tracking-[0.18em] text-green sm:text-[0.7rem]" data-id="element-105" data-mp="tzmpbovden86">
          Special Launch Offer
        </p>
        <h2 className="mt-2.5 text-xl text-white sm:text-3xl" data-id="element-106" data-mp="13ylx758baeu4">🔩 Metal Fabrication Ready™</h2>
        <p className="mt-1 font-display text-xs font-bold uppercase tracking-wide text-gold sm:text-sm" data-id="element-107" data-mp="ywd5sdb37ku4">
          The Complete Ready-to-Build Metal Fabrication Collection
        </p>

        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="mt-3 block rounded-lg focus:outline-none focus-visible:ring-4 focus-visible:ring-green/40" data-id="element-108" data-mp="2acbj4tdast15">
          <img src={PRODUCT_IMAGE} alt="METAL FABRICATION READY™ complete digital package with 5 exclusive bonuses" className="mx-auto w-full max-w-[15rem] rounded-lg shadow-2xl shadow-black/60 sm:max-w-xs" data-id="element-109" data-mp="uhh46y18oqvp" />
        </a>

        <div className="mt-3.5 rounded-lg border border-steelLine bg-charcoal p-4 text-left" data-id="element-110" data-mp="6usehq5znu4j">
          <p className="font-display text-xs font-bold uppercase tracking-wide text-lightGray" data-id="element-111" data-mp="btvlvh9fycfo">
            Everything in one complete digital package:
          </p>
          <ul className="mt-2 grid gap-1.5 sm:grid-cols-2" data-id="element-112" data-mp="kl4cg5p98n3l">
            {offerIncludes.map(item => <li key={item} className="flex items-start gap-1.5 text-sm font-medium text-white" data-id="element-113" data-mp="3k8vqkgpyi87q">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-green" aria-hidden="true" data-id="element-114" data-mp="3o9z9xd77qmdp" />
                {item}
              </li>)}
          </ul>
          <div className="mt-3.5 flex items-end justify-center gap-2 border-t border-steelLine pt-3" data-id="element-115" data-mp="vdnwwp85g39r">
            <span className="font-display text-4xl font-black text-white sm:text-5xl" data-id="element-116" data-mp="qejnbxhbc3iw">$27</span>
            <span className="pb-1 font-display text-[0.65rem] font-bold uppercase tracking-wider text-steelGray sm:text-xs" data-id="element-117" data-mp="157mvje90l4wy">
              One-time payment
            </span>
          </div>
          <p className="mt-1 text-center font-display text-xs font-extrabold uppercase tracking-wide text-gold" data-id="element-118" data-mp="ch4vyn7i1loa">
            🔥 Get Metal Fabrication Ready™ Today
          </p>
          <div className="mt-3" data-id="element-119" data-mp="licgm2h3enzw">
            <CTAButton href={CHECKOUT_URL} external sub="One-Time Payment • Immediate Digital Delivery" data-id="element-120" data-mp="lfgjggd2k3ci">
              Yes! I Want Instant Access
            </CTAButton>
          </div>
          <p className="mt-2 flex items-center justify-center gap-1.5 text-[0.7rem] font-bold text-gold sm:text-xs" data-id="element-121" data-mp="1wuwsdcigrr0j">
            <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-122" data-mp="1sxh7ltliepg5" /> 🛡️ 14-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}